import React, { useEffect, useState } from 'react'
import { FormGroup, Label } from 'reactstrap'
import InputSelectCustom from '../Common/InputSelectCustom'
import InputSelectMultiCustom from '../Common/InputSelectMultiCustom';
import { replaceFlagByInputValue } from '../../helpers/functions'
import BizinBackend from '../../helpers/bizin_helper'
import { useSelector } from 'react-redux'
import useGetCsrfToken from '../../Hooks/useGetCsrfToken';

const processBackend = async (
  proc_name,
  proc_params,
  cookies,
  access_token_msman,
  payload = []
) => {
  try {
    let data = payload
    if(!payload || !payload.length){
      data = await BizinBackend.executeProcedure(
        proc_params,
        proc_name,
        cookies,
        access_token_msman
      )
    }

    if (data.length) {
      const options = data.map(item => ({
        value: Object.values(item)[0],
        label: Object.values(item)[1]
      }))
      return options
    }
  } catch (error) {
    return 'Erro ao buscar dados [combobox] :' + error
  }
}

const ComboBoxAutomatic = ({
  id,
  titulo,
  placeholder,
  isDisabled,
  initialValue = [],
  alienated = [],
  dataOptions = [],
  valueOptions = [],
  idAlienated,
  procName,
  procParams,
  isMulti = false,
  callbackSelected = () => {},
  callbackRemoveSelected = () => {}
}) => {
  console.log("dataOptions: ", dataOptions)
  const csrfToken = useGetCsrfToken()
  const [displayedOptions, setdisplayedOptions] = useState(dataOptions)
  const [value, setValue] = useState(initialValue)
  const [isLoading, setIsLoading] = useState(false)
  const user = useSelector(state => state.login.user)
  const [alienatedProps, setAlienatedProps] = useState(alienated)

  const loadOptions = (inputValue, callback) => {
    if (inputValue) {
      const filteredOptions = displayedOptions.filter(option =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      )
      callback(filteredOptions)
    } else {
      callback(displayedOptions)
    }
  }

  const getData = async () => {
    setIsLoading(true)
    let params = procParams

    if (alienated && alienated.length) {
      console.log('alienated', alienated, JSON.stringify(params))
      params = replaceFlagByInputValue(JSON.stringify(params), alienated)
    }

    const data = await processBackend(
      procName,
      Object.assign({}, params),
      csrfToken,
      user?.access_token,
      valueOptions
    )
    
    setIsLoading(false)
    setValue([])
    setdisplayedOptions(data)
  }

  useEffect(() => {
    if (!isDisabled && !value?.length && !alienatedProps?.length && !displayedOptions?.length) {
      getData()
    }    
  }, [isDisabled])
  
  useEffect(() => {
    if(JSON.stringify(alienatedProps) === JSON.stringify(alienated)) return
    setAlienatedProps(alienated)
    
    if(!alienated?.length) return      
    if (!isDisabled && Object.keys(alienated[0]) && alienated[0][idAlienated[0]]?.value) {
      callbackRemoveSelected(id);
      getData()
    }
  }, [alienated])

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  useEffect(() => {
    if(!!initialValue && initialValue?.value){
      callbackSelected({ [id]: initialValue });
    }
  }, [])

  return (
    <FormGroup>
      <Label>{titulo}</Label>
      <div>
        {isMulti ? (
          <InputSelectMultiCustom
            id={id}
            name={titulo}
            stateSelected={initialValue[0]?.values || initialValue}
            optionsData={displayedOptions}
            placeholder={placeholder}
            isLoading={isLoading}
            isDisabled={isLoading || isDisabled}
            loadOptions={loadOptions}
            handleOnChange={(selected) => {              
              callbackSelected({ [id]: [{values: (selected), field: titulo}] });
              setValue(selected);
            }}
          />
        ) : (
          <InputSelectCustom
            id={id}
            name={titulo}
            stateSelected={value}
            optionsData={displayedOptions}
            placeholder={placeholder}
            isLoading={isLoading}
            isDisabled={isLoading || isDisabled}
            loadOptions={loadOptions}
            handleOnChange={(selected) => {
              const payload = { ...selected, field: titulo, isSelect: true };
              callbackSelected({ [id]: payload });
              setValue(selected)
            }}
         />
        )}
      </div>
    </FormGroup>
  );
}

export default ComboBoxAutomatic